import React, {FC} from "react";
import {Divider, IconButton, Menu, Typography} from "@mui/material";
import {useTopBar} from "../../hooks/useTopBar";
import {
    UseManageWorkspacesAndOrganizations
} from "../../../../authWorkspacesCookies/workspaces/hooks/useManageWorkspacesAndOrganizations";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useHistory} from "react-router";
import {
    //PATH_LOCAL_HELP,
    //PATH_LOCAL_NOTIFICATIONS,
    PATH_LOCAL_SETTINGS,
    PATH_LOCAL_USER_PROFILE,
    SHOW_CHANGE_LANGUAGE_IN_TOPBAR
} from "../../../../../newShared/constants";
import colors from "../../../../../newShared/theme/colors";
import {MoreVert} from "@mui/icons-material";
import {MenuItemHoverBlue} from "../styled";
import {useMedia} from "../../../../../newShared/hooks/useMedia";
import {AvatarMenuTitle} from "../avatarMenuTitle";
import {CommonAvatar} from "../../../../../newShared/components/Basic/CommonAvatar";
import {getName} from "../../../../../newShared/utils/text";
import {ChangeLanguageDialog} from "../../../../../newShared/components/changeLanguageDialog/hook";
import {LanguageChangeDialog} from "../../../../../newShared/components/changeLanguageDialog";
import {MobileMenuDialog} from "../mobileMenuDialog";
import {useDispatch} from "react-redux";
import {ContactUsDialog} from "../../../../components/contactUs/contactUsDialog";
import {setContactUsDialogAction} from "../../../../components/contactUs/store/slice";
import {SETTINGS_LANGUAGE_PATH} from "../../../../authWorkspacesCookies/settings/constants";


export const ThreeDotsTopBar: FC = () => {
    const {t} = useMainTranslation('', {keyPrefix: 'TopBar.threeDots'});
    const history = useHistory();
    const {toggleVisibility, isOpen} = ChangeLanguageDialog();
    const dispatch = useDispatch();
    const openContactUsDialog = () => {
        dispatch(setContactUsDialogAction({isOpen: true}))
        handleThreeDotsClose();
    }
    const {currData: {currentUser}, logout} = UseManageWorkspacesAndOrganizations();
    const {
        anchorThreeDotsEl, handleThreeDotsOpen, handleThreeDotsClose,
        //handleGoToMain,
        // handleGoToReports,
        //handleGoToPortal,
    } = useTopBar();
    const {isMobile} = useMedia();

    const handleSelect = (path: string) => {
        history.push(path);
        handleThreeDotsClose()
    }

    return currentUser ? (
        <>
            <IconButton
                onClick={handleThreeDotsOpen}
                size={"large"}
                sx={{color: Boolean(anchorThreeDotsEl) ? colors.primary.blue : colors.text.grey_dark}}
            >
                <MoreVert/>
            </IconButton>
            <Menu
                keepMounted
                elevation={1}
                anchorEl={anchorThreeDotsEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorThreeDotsEl) && !isMobile}
                onClose={handleThreeDotsClose}
                style={{top: '6px'}}
                MenuListProps={{sx: {py: '0'}}}
            >
                {/*<MenuItem onClick={handleGoToMain}>*/}
                {/*    {t('Go to Main app')}*/}
                {/*</MenuItem>*/}
                <AvatarMenuTitle name={getName(currentUser.firstName, currentUser.lastName)} email={currentUser.email} isDesktop={false} handleClose={handleThreeDotsClose}>
                    <CommonAvatar name={getName(currentUser.firstName, currentUser.lastName)}
                                  size={'d28'} style={{cursor: 'default'}}/>
                </AvatarMenuTitle>
                <Divider sx={{margin: '0 !important'}}/>
                {/*<MenuItemHoverBlue onClick={() => {handleOpenSelectWorkspaceDialog(); handleThreeDotsClose();}}>*/}
                {/*    <Typography variant={'*bodyText2'} color={colors.text.dark}>{t('Change workspace')}</Typography>*/}
                {/*</MenuItemHoverBlue>*/}
                <MenuItemHoverBlue onClick={() => {handleSelect(PATH_LOCAL_SETTINGS)}}>
                    <Typography variant={'*bodyText2'} color={colors.text.dark}>{t('Settings')}</Typography>
                </MenuItemHoverBlue>
                <MenuItemHoverBlue onClick={openContactUsDialog}>
                    <Typography variant={'*bodyText2'} color={colors.text.dark}>{t('Contact us')}</Typography>
                </MenuItemHoverBlue>
                <MenuItemHoverBlue onClick={() => {handleSelect(PATH_LOCAL_USER_PROFILE)}}>
                    <Typography variant={'*bodyText2'} color={colors.text.dark}>{t('Profile')}</Typography>
                </MenuItemHoverBlue>
                <MenuItemHoverBlue onClick={() => {handleSelect(SETTINGS_LANGUAGE_PATH)}}>
                    <Typography variant={'*bodyText2'} color={colors.text.dark}>{t('Language')}</Typography>
                </MenuItemHoverBlue>
                {SHOW_CHANGE_LANGUAGE_IN_TOPBAR &&
                    <MenuItemHoverBlue onClick={() => {
                        toggleVisibility(true);
                        handleThreeDotsClose();
                    }}>
                        <Typography color={colors.text.dark} variant={'*bodyText2'}>{t('Change language')}</Typography>
                    </MenuItemHoverBlue>
                }

                <Divider sx={{margin: '0 !important'}}/>

                <MenuItemHoverBlue onClick={() => {handleThreeDotsClose(); logout()}}>
                    <Typography variant={'*bodyText2'} color={colors.text.dark}>{t('Logout')}</Typography>
                </MenuItemHoverBlue>
            </Menu>
            <LanguageChangeDialog isOpen={isOpen} handleClose={toggleVisibility}/>
            <MobileMenuDialog isOpen={Boolean(anchorThreeDotsEl) && isMobile} handleClose={handleThreeDotsClose}/>
            <ContactUsDialog />
        </>
    ) : null
}